import request from '@/utils/request'
import { getShopId } from '@/utils/vc'

/**
 * 抵扣金后台管理统一查询
 * @param {Object} params 查询参数（需包含 action）
 */
export function propertyDeductionAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/propertyDeduction.admin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 商家抵扣金报表查询
 * @param {Object} params 查询参数
 */
export function queryShopDeductionReport(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/propertyDeduction.queryShopDeductionReport',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
